(function () {
  var trackingKeys = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'fbclid',
    'gclid',
    'ttclid',
    'twclid',
    'msclkid'
  ];

  function addTrackingParameters(href) {
    try {
      var destination = new URL(href, window.location.origin);
      var source = new URLSearchParams(window.location.search);

      trackingKeys.forEach(function (key) {
        if (source.has(key) && !destination.searchParams.has(key)) {
          destination.searchParams.set(key, source.get(key));
        }
      });

      return destination.toString();
    } catch (error) {
      return href;
    }
  }

  function padTime(value) {
    return value < 10 ? '0' + value : String(value);
  }

  function initializeScrollLockGuard() {
    var body = document.body;

    if (!body || !body.classList.contains('template-presell') || body.presellScrollLockObserver) return;

    function releaseKlaviyoScrollLock() {
      if (!body.classList.contains('klaviyo-prevent-body-scrolling')) return;

      body.classList.remove('klaviyo-prevent-body-scrolling');

      if (body.style.overflow === 'hidden') {
        body.style.removeProperty('overflow');
      }
    }

    releaseKlaviyoScrollLock();

    body.presellScrollLockObserver = new MutationObserver(releaseKlaviyoScrollLock);
    body.presellScrollLockObserver.observe(body, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  function initializeCountUp(root) {
    var timers = Array.prototype.slice.call(root.querySelectorAll('[data-presell-count-up]'));
    if (!timers.length || root.presellCountUpInterval) return;

    timers.forEach(function (timer) {
      timer.setAttribute('data-presell-count-up-initialized', 'true');
    });

    var stateKey = 'blackout_presell_count_up_state';
    var state = null;

    try {
      state = JSON.parse(window.sessionStorage.getItem(stateKey));
    } catch (error) {
      state = null;
    }

    if (
      !state ||
      !Number.isFinite(state.startedAt) ||
      !Number.isFinite(state.seedSeconds) ||
      state.seedSeconds < 3600
    ) {
      state = {
        startedAt: Date.now(),
        seedSeconds: 3600 + Math.floor(Math.random() * 7200)
      };

      try {
        window.sessionStorage.setItem(stateKey, JSON.stringify(state));
      } catch (error) {
        // Continue with the in-memory randomized value when storage is unavailable.
      }
    }

    var timerNodes = timers.map(function (timer) {
      return {
        timer: timer,
        hours: timer.querySelector('[data-presell-hours]'),
        minutes: timer.querySelector('[data-presell-minutes]'),
        seconds: timer.querySelector('[data-presell-seconds]')
      };
    });

    function updateCountUp() {
      var elapsedSeconds = Math.max(0, Math.floor((Date.now() - state.startedAt) / 1000));
      var totalSeconds = state.seedSeconds + elapsedSeconds;
      var hours = Math.floor(totalSeconds / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      timerNodes.forEach(function (nodes) {
        nodes.hours.textContent = padTime(hours);
        nodes.minutes.textContent = padTime(minutes);
        nodes.seconds.textContent = padTime(seconds);
        nodes.timer.setAttribute(
          'aria-label',
          'Elapsed session time: ' +
            hours +
            (hours === 1 ? ' hour, ' : ' hours, ') +
            minutes +
            (minutes === 1 ? ' minute, ' : ' minutes, ') +
            seconds +
            (seconds === 1 ? ' second' : ' seconds')
        );
      });
    }

    updateCountUp();
    root.presellCountUpInterval = window.setInterval(updateCountUp, 1000);
  }

  function initializeRoot(root) {
    if (!root || root.getAttribute('data-presell-initialized') === 'true') return;
    root.setAttribute('data-presell-initialized', 'true');

    var pageType = root.getAttribute('data-presell-type') || 'unknown';
    var links = root.querySelectorAll('[data-presell-cta]');
    var sticky = root.querySelector('[data-presell-sticky]');
    var desktopSticky = root.querySelector('[data-presell-desktop-sticky]');
    var primaryOffer = root.querySelector('.presell__offer--full');
    var opening = root.querySelector('[data-presell-opening]');

    initializeCountUp(root);

    links.forEach(function (link) {
      var enhancedHref = addTrackingParameters(link.getAttribute('href'));
      link.setAttribute('href', enhancedHref);

      link.addEventListener('click', function () {
        var destinationPath = enhancedHref;

        try {
          destinationPath = new URL(enhancedHref, window.location.origin).pathname;
        } catch (error) {
          destinationPath = enhancedHref;
        }

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'presell_cta_click',
          presell_page_type: pageType,
          presell_cta_placement: link.getAttribute('data-presell-placement') || 'unknown',
          presell_destination: destinationPath
        });
      });
    });

    if (!opening) return;

    if (sticky) {
      function setStickyVisibility() {
        var openingBottom = opening.getBoundingClientRect().bottom;
        var stickyHeight = sticky.offsetHeight || 0;
        var visibleContentBottom = window.innerHeight - stickyHeight;
        var anotherCtaIsVisible = Array.prototype.some.call(links, function (link) {
          if (sticky.contains(link)) return false;

          var linkRect = link.getBoundingClientRect();
          return linkRect.bottom > 0 && linkRect.top < visibleContentBottom;
        });

        sticky.classList.toggle('is-visible', openingBottom < 0 && !anotherCtaIsVisible);
      }

      setStickyVisibility();
      window.addEventListener('scroll', setStickyVisibility, { passive: true });
      window.addEventListener('resize', setStickyVisibility);
    }

    if (desktopSticky) {
      function setDesktopStickyVisibility() {
        var openingHasPassed = opening.getBoundingClientRect().bottom < 0;
        var primaryOfferIsVisible = false;

        if (primaryOffer) {
          var offerRect = primaryOffer.getBoundingClientRect();
          primaryOfferIsVisible = offerRect.bottom > 0 && offerRect.top < window.innerHeight;
        }

        desktopSticky.classList.toggle('is-visible', openingHasPassed && !primaryOfferIsVisible);
      }

      setDesktopStickyVisibility();
      window.addEventListener('scroll', setDesktopStickyVisibility, { passive: true });
      window.addEventListener('resize', setDesktopStickyVisibility);
    }
  }

  initializeScrollLockGuard();
  document.querySelectorAll('[data-presell-root]').forEach(initializeRoot);

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.matches('[data-presell-root]')
      ? event.target
      : event.target.querySelector('[data-presell-root]');
    initializeRoot(root);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.matches('[data-presell-root]')
      ? event.target
      : event.target.querySelector('[data-presell-root]');

    if (root && root.presellCountUpInterval) {
      window.clearInterval(root.presellCountUpInterval);
    }
  });
})();
